<button
  cdkOverlayOrigin
  #triggerBalancePopover="cdkOverlayOrigin"
  (click)="headerBalanceService.toggleBalancePopover()"
  class="balance-button button h-40 rounded-6 button--style-dropdown"
  [class.active]="headerBalanceService.isOpenBalancePopover()"
>
  <app-balance-icon [balance]="balanceType()" />
  <number-flow #mainCostNumberFlow></number-flow>
  <button
    cdkOverlayOrigin
    #triggerWalletPopover="cdkOverlayOrigin"
    class="button rounded-4 h-32 padding-x-12 button--style-primary wallet"
    [class.active]="headerBalanceService.isOpenWalletPopover()"
    (click)="
      $event.stopPropagation();
      headerBalanceService.toggleBalancePopover('hide');
      headerBalanceService.toggleWalletPopover()
    "
  >
    <span>Wallet</span>
    <svg-icon
      class="flex items-center justify-center s-16"
      src="assets/icons/shared/wallet.svg"
    />
  </button>
</button>
<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="triggerBalancePopover"
  [cdkConnectedOverlayOpen]="headerBalanceService.isOpenBalancePopover()"
  (detach)="headerBalanceService.toggleBalancePopover('hide')"
>
  <div
    class="balance-menu dropdown--items-container header-dropdown"
    (clickOutside)="headerBalanceService.toggleBalancePopover('hide')"
  >
    <div
      class="balance-item dropdown--item"
      [class.active]="balanceType() === 'skins'"
      (click)="changeBalanceType('skins')"
    >
      <app-balance-icon balance="skins"></app-balance-icon>
      <span>Skins Balance</span>
      <app-cost [showIcon]="false" [cost]="balance().skins"></app-cost>
    </div>
    <div
      class="balance-item dropdown--item"
      [class.active]="balanceType() === 'pure'"
      (click)="changeBalanceType('pure')"
    >
      <app-balance-icon balance="pure"></app-balance-icon>

      <span>Pure Balance</span>
      <app-cost [showIcon]="false" [cost]="balance().pure"></app-cost>
    </div>
    @if (isShowBonusBalance()) {
    <div
      class="balance-item dropdown--item"
      [class.active]="balanceType() === 'bonus'"
      (click)="changeBalanceType('bonus')"
    >
      <app-balance-icon balance="bonus"></app-balance-icon>

      <span>Bonus Balance</span>
      <app-cost [showIcon]="false" [cost]="balance().bonus"></app-cost>
    </div>
    }

    <span class="divider horizontal w-full my-8"></span>
    <div
      (click)="
        openOurDeposits(); headerBalanceService.toggleBalancePopover('hide')
      "
      class="difference"
    >
      What is the difference?
    </div>
  </div>
</ng-template>
<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="triggerWalletPopover"
  [cdkConnectedOverlayOpen]="headerBalanceService.isOpenWalletPopover()"
  (detach)="headerBalanceService.toggleWalletPopover('hide')"
>
  <div
    class="wallet-menu dropdown--items-container header-dropdown"
    (clickOutside)="headerBalanceService.toggleWalletPopover('hide')"
  >
    <a
      class="wallet-item dropdown--item"
      (click)="headerBalanceService.toggleWalletPopover('hide')"
      routerLink="deposit"
      routerLinkActive="active"
    >
      <svg-icon
        class="flex items-center justify-center s-16"
        src="assets/icons/ui/plus.svg"
      />
      <span>Deposit</span>
    </a>
    <a
      class="wallet-item dropdown--item"
      (click)="headerBalanceService.toggleWalletPopover('hide')"
      routerLinkActive="active"
      routerLink="withdraw"
    >
      <svg-icon
        class="flex items-center justify-center s-16"
        src="assets/icons/ui/output.svg"
      />
      <span>Withdraw</span>
    </a>
    <a
      class="wallet-item dropdown--item"
      (click)="headerBalanceService.toggleWalletPopover('hide')"
      routerLinkActive="active"
      routerLink="rewards"
    >
      <svg-icon
        class="flex items-center justify-center s-16"
        src="assets/icons/features/rewards.svg"
      />
      <span>Free coins</span>
    </a>
  </div>
</ng-template>
